module.exports = __webpack_public_path__ + "static/media/microsoft365Signin.8805a506.png";